module.exports = __webpack_public_path__ + "static/assets/7cd8620d7571448c33d16d1a187e2f4c.png";